/**
 * Get the homepage URL for a user based on their department settings.
 * @param {Object} user - The user object
 * @param {Array} hospitals - Array of hospitals with departments
 * @returns {string|null} - The homepage URL or null if not found
 */
export const getDepartmentHomepage = (user, hospitals) => {
  if (user?.isSuperAdmin || !hospitals) {
    return null;
  }

  for (const hospital of hospitals) {
    for (const department of hospital.departments) {
      if (department.homepage) {
        return department.homepage;
      }
    }
  }

  return null;
};
